import { FormControl } from '@angular/forms';

import * as Services from '@shared/core/services';

import { Observable } from 'rxjs';
import { map, delay } from 'rxjs/operators';

export const memberCardIsRegisteredValidator = (membersService: Services.MembersService, delayResponse: number = 0) => {
    return (control: FormControl): Observable<OLO.Common.IValidators> | Promise<OLO.Common.IValidators> => {
        if (!control.value) {
            return Promise.resolve(null);
        }

        return membersService.validateMemberByMemberCard(control.value)
            .pipe(
                delay(delayResponse),
                map(isAvailable => {
                    return isAvailable ?
                        null : isAvailable === false ?
                            { cardTaken: `Card has already been registered` } :
                            { cardNotRegistered: `Card number is not valid` };
                })
            );
    };
};
